
import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { Loader2 } from "lucide-react";
import { Capacitor } from '@capacitor/core';

interface PaymentRequestButtonProps {
  paymentRequest: any;
  paymentMethod: string;
  isProcessing?: boolean;
}

const PaymentRequestButton = ({ paymentRequest, paymentMethod, isProcessing = false }: PaymentRequestButtonProps) => {
  // Check if running on native platform
  const isNative = Capacitor.isNativePlatform();
  
  // Set appropriate button style based on payment method
  const buttonTheme = paymentMethod === 'google-pay' ? 'dark' : 
                      paymentMethod === 'apple-pay' ? 'dark' : 'light';
  
  // Customize button height and type based on payment method
  const buttonType = 'buy';
  const buttonHeight = '40px';
  
  // Adjust styles for mobile native
  const mobileStyles = isNative ? { 
    scale: '1.05',
    borderRadius: '8px',
  } : {};
  
  return (
    <div className={`mt-4 ${isNative ? 'px-2' : ''}`}>
      {isProcessing ? (
        <div className="w-full flex items-center justify-center py-3 bg-gray-100 rounded">
          <Loader2 className="h-5 w-5 mr-2 text-blue-500 animate-spin" />
          <span>Processing payment...</span>
        </div>
      ) : (
        <PaymentRequestButtonElement 
          options={{ 
            paymentRequest,
            style: {
              paymentRequestButton: {
                theme: buttonTheme,
                height: buttonHeight,
                type: buttonType,
                ...mobileStyles
              }
            }
          }} 
          className="w-full" 
        />
      )}
      <p className="text-sm text-center mt-4 text-gray-600">
        {paymentMethod === 'google-pay' && 'Click the button above to pay with Google Pay'}
        {paymentMethod === 'apple-pay' && 'Click the button above to pay with Apple Pay'}
      </p>
    </div>
  );
};

export default PaymentRequestButton;
